import { render, staticRenderFns } from "./createLive.vue?vue&type=template&id=7a72c8a8&scoped=true&"
import script from "./createLive.vue?vue&type=script&lang=js&"
export * from "./createLive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72c8a8",
  null
  
)

export default component.exports